<template>
    <el-switch v-bind="$attrs" v-on="$listeners" v-if="isShow"></el-switch>
</template>
<script>
    export default {
        props: ["id"],
        computed: {
            // 根据权限控制按钮的显示隐藏
            isShow() {
                return this.$store.getters.buttonsAuth.indexOf(this.id) != -1
                    ? true
                    : false;
            }
        }
    };
</script>